import { assignmentModule } from '@/store/assignment/module'
import { userModule } from '@/store/user/module'
import type { Study } from '@pocketprep/types'

const getAreAssignmentsEnabled = () => {
    return userModule.state.userFlags.assignmentsEnabled
}

const getSortedAvailableAssignments = () => {
    const assignments = assignmentModule.state.assignments
    return assignments.sort((a, b) => {
        if (
            a.dueDate?.iso
            && a.availableDate?.iso
            && b.dueDate?.iso
            && b.availableDate?.iso
        ) {
            const aDueDateTimestamp = new Date(a.dueDate.iso).getTime()
            const aAvailableTimestamp = new Date(a.availableDate.iso).getTime()
            const bDueDateTimestamp = new Date(b.dueDate.iso).getTime()
            const bAvailableTimestamp = new Date(b.availableDate.iso).getTime()
            return aDueDateTimestamp - bDueDateTimestamp
                || aAvailableTimestamp - bAvailableTimestamp || a.name.localeCompare(b.name)
        }
        // fall back just in case for some reason the due/available dates are not on the assignment
        return a.name.localeCompare(b.name)
    })

}

const getHoursUntilAssignmentIsDue = (assignment: Study.Class.PrebuiltQuizJSON) => {
    const assignmentDueDateIsoDate = assignment.dueDate?.iso
    const today = new Date()
    const todayTimeStamp = today.getTime()

    if (assignmentDueDateIsoDate) {
        const assignmentDueDateDate = new Date(assignmentDueDateIsoDate)
        const diffInMs = Math.abs(assignmentDueDateDate.getTime() - todayTimeStamp)
        const hoursUntilDue = (diffInMs / (1000 * 60 * 60))
        return hoursUntilDue
    }

    return null
}

const getAssignment = () => {
    return assignmentModule.state.assignment
}

const getAssignmentQuestions = () => {
    return assignmentModule.state.assignmentQuestions
}

const getCompletedAssignment = () => {
    return assignmentModule.state.completedAssignment
}

const getAssignmentFormattedDate = (assignmentDueDateIsoDate: string) => {
    const today = new Date()
    const thisYear = today.getFullYear()
    const assignmentDueDate = new Date(assignmentDueDateIsoDate)
    const assignmentDueDateYear = assignmentDueDate.getFullYear()

    if (thisYear !== assignmentDueDateYear) {
        return assignmentDueDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        })
    }

    return assignmentDueDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
    })
}

const getIsAssignmentPastDue = (assignmentDueDateIso: string | undefined) => {
    const now = new Date()

    if (assignmentDueDateIso) {
        const assignmentDueDateTime = new Date(assignmentDueDateIso)
        return now.getTime() > assignmentDueDateTime.getTime()
    }

    return false
}

export default {
    getAreAssignmentsEnabled,
    getSortedAvailableAssignments,
    getHoursUntilAssignmentIsDue,
    getAssignment,
    getAssignmentFormattedDate,
    getAssignmentQuestions,
    getCompletedAssignment,
    getIsAssignmentPastDue,
}
